<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createMapa"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedMapsContentModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="proyecto.titulo"
          :inputError="$v.proyecto.titulo.$error"
          :label="$t('mFeedMapsContentModalCreate.inputs.titulo.label')"
          :message="$t('mFeedAssetsContentModalCreate.inputs.titulo.message')"
          :messageError="messageErrorTitulo"
          name="titulo"
          type="text"
          @blur="$v.proyecto.titulo.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedMapsContentModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedMapsContentModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedMapsContentModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      proyecto: {
        academia: '',
        proyecto_categoria: 1,
        proyecto_tipo: 1,
        titulo: ''
      }
    }
  },

  validations: {
    proyecto: {
      titulo: {
        maxLength: maxLength(120),
        minLength: minLength(5),
        required
      }
    }
  },

  computed: {
    messageErrorTitulo () {
      return this.$validation.getValidationMessage('mFeedMapsContentModalCreate', this.$v.proyecto.titulo, 'titulo')
    }
  },

  created () {
    this.proyecto.academia = this.$store.getters.getAcademyData.id
  },

  methods: {
    createMapa () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('proyecto', 'createMapa', this.proyecto)
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedMapsContentModalCreate', 'createMapa', 'success')
            this.$router.push(`/${this.$t('rPaths.map')}/${response.data.id}/${this.$t('mEditionMenu.map.card.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedMapsContentModalCreate', 'createMapa', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
